// libs
import React from 'react';
import PropTypes from 'prop-types';

// Required Components
import Linklist from './Linklist';


// Props and Context
const propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.object,
  className: PropTypes.string,
};

const defaultProps = {
  links: [],
  location: {},
  className: 'sitenav',
};

const contextTypes = {
  t: PropTypes.func,
};


// Index Component
function Nav(props) {
  const { className: classes, location } = props;
  return (
    <nav className={`${classes}__nav`} >
      <Linklist location={location} {...props} />
    </nav>
  );
}

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

export default Nav;



// WEBPACK FOOTER //
// ./src/app/components/layouts/nav/Nav.js